import OnlineMeetingDropdown from './OnlineMeetingDropdown';
import OnlineMeetingToggle from './OnlineMeetingToggle';
import type { ITheme } from '@fluentui/react/lib/Styling';
import shouldEnableDefaultOnlineMeeting from 'owa-calendar-compose-form-orchestration/lib/utils/shouldEnableDefaultOnlineMeeting';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { isFeatureEnabled } from 'owa-feature-flags';
import * as React from 'react';
import {
    isSupportedOnlineMeetingProvider,
    getDefaultOnlineMeetingProvider,
    OnlineMeetingProviderType,
} from 'owa-online-meeting';

export default function getOnlineMeetingProviderSelector(
    providers: OnlineMeetingProviderType[],
    theme: ITheme,
    event: CalendarEvent,
    colorScheme: ColorScheme,
    formId: string,
    compactMode: Boolean,
    isDarkMode?: boolean,
    dropdownContainerClassName?: string,
    hideDropdownTitleIcon?: boolean,
    disabled?: boolean
): JSX.Element {
    if (providers.length >= 2) {
        return (
            <OnlineMeetingDropdown
                providers={providers}
                theme={theme}
                event={event}
                colorScheme={colorScheme}
                formId={formId}
                dropdownContainerClassName={dropdownContainerClassName}
                hideDropdownTitleIcon={hideDropdownTitleIcon}
                disabled={disabled}
                shouldShowTooltip={shouldEnableDefaultOnlineMeeting(event, formId)}
            />
        );
    } else if (providers.length === 1 && isSupportedOnlineMeetingProvider(providers[0])) {
        const onlineMeetingProvider = providers[0];

        // Don't allow to turn off the toggle for channel meetings
        const forceTeamsMeeting =
            isFeatureEnabled('cal-mf-calendarPickerTeams') &&
            event.IsOnlineMeeting &&
            event.SkypeTeamsProperties &&
            getDefaultOnlineMeetingProvider(event) === 'TeamsForBusiness';

        return (
            <OnlineMeetingToggle
                isOnlineMeeting={event.IsOnlineMeeting}
                provider={onlineMeetingProvider}
                colorScheme={colorScheme}
                canChangeToggle={!forceTeamsMeeting}
                formId={formId}
                isDarkMode={isDarkMode}
                compactMode={compactMode}
                disabled={disabled}
                shouldShowTooltip={shouldEnableDefaultOnlineMeeting(event, formId)}
            />
        );
    } else {
        return null;
    }
}
